import { OrderedProduct } from '@ravago/shared/page-data/models/elements';
import { CustomerDataPage } from '@ravago/shared/page-data/models/pages';

export async function getAllOrderedProducts(): Promise<CustomerDataPage<OrderedProduct> | undefined> {
  const response = await fetch('/api/customer/ordered-products');
  if (!response.ok) return undefined;
  return response.json();
}
